// 三国志 — Tier-B bundle (CLIENT only). Layers images over Tier-A. Generated by create-mod.
// NEVER import from Game.js / server.js / the sim / tests (pulls the keyArt PNG + globe lib).
import { sanguoExcerptData } from './bundle.data';
import { CHARACTERS } from './characters';
import keyArt from '../dominion/keyart.png';
import { getGlobe } from '../dominion/atlas/globe-lib';
import boardBg from './backgrounds/sanguo-excerpt.png';

export const sanguoExcerptClient = Object.assign({}, sanguoExcerptData, {
  characters: CHARACTERS,
  portraits: {},
  keyArt: keyArt,
  atlasAssets: { 'sanguo-excerpt': { worldBg: boardBg, cityImages: {} } },
  getGlobe: getGlobe,
});

export default sanguoExcerptClient;
